"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: account/installment-loan-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Faccount%2Finstallment-loan-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.InstallmentLoanServiceClient = exports.LookupInstallmentLoanResponse = exports.LookupInstallmentLoanRequest = exports.SetInstallmentLoanAutoPayResponse = exports.SetInstallmentLoanAutoPayRequest = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const account_1 = require("./account");
const protobufPackage = 'com.step.account.proto';
function createBaseSetInstallmentLoanAutoPayRequest() {
    return { accountId: '', autoPay: false };
}
exports.SetInstallmentLoanAutoPayRequest = {
    fromJSON(object) {
        const message = {
            accountId: isSet(object.accountId) ? globalThis.String(object.accountId) : '',
        };
        if (isSet(object.autoPay)) {
            message.autoPay = globalThis.Boolean(object.autoPay);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.accountId !== '') {
            obj.accountId = message.accountId;
        }
        if (message.autoPay !== undefined && message.autoPay !== false) {
            obj.autoPay = message.autoPay;
        }
        return obj;
    },
    create(base) {
        return exports.SetInstallmentLoanAutoPayRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSetInstallmentLoanAutoPayRequest();
        message.accountId = object.accountId ?? '';
        message.autoPay = object.autoPay ?? false;
        return message;
    },
};
function createBaseSetInstallmentLoanAutoPayResponse() {
    return { account: account_1.Account.fromPartial({}) };
}
exports.SetInstallmentLoanAutoPayResponse = {
    fromJSON(object) {
        const message = {
            account: isSet(object.account) ? account_1.Account.fromJSON(object.account) : account_1.Account.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.account !== undefined) {
            obj.account = account_1.Account.toJSON(message.account);
        }
        return obj;
    },
    create(base) {
        return exports.SetInstallmentLoanAutoPayResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSetInstallmentLoanAutoPayResponse();
        message.account = (object.account !== undefined && object.account !== null)
            ? account_1.Account.fromPartial(object.account)
            : account_1.Account.fromPartial({});
        return message;
    },
};
function createBaseLookupInstallmentLoanRequest() {
    return { paymentId: '' };
}
exports.LookupInstallmentLoanRequest = {
    fromJSON(object) {
        const message = {
            paymentId: isSet(object.paymentId) ? globalThis.String(object.paymentId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.paymentId !== '') {
            obj.paymentId = message.paymentId;
        }
        return obj;
    },
    create(base) {
        return exports.LookupInstallmentLoanRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseLookupInstallmentLoanRequest();
        message.paymentId = object.paymentId ?? '';
        return message;
    },
};
function createBaseLookupInstallmentLoanResponse() {
    return { subAccount: account_1.AccountSubAccount.fromPartial({}) };
}
exports.LookupInstallmentLoanResponse = {
    fromJSON(object) {
        const message = {
            subAccount: isSet(object.subAccount)
                ? account_1.AccountSubAccount.fromJSON(object.subAccount)
                : account_1.AccountSubAccount.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.subAccount !== undefined) {
            obj.subAccount = account_1.AccountSubAccount.toJSON(message.subAccount);
        }
        return obj;
    },
    create(base) {
        return exports.LookupInstallmentLoanResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseLookupInstallmentLoanResponse();
        message.subAccount = (object.subAccount !== undefined && object.subAccount !== null)
            ? account_1.AccountSubAccount.fromPartial(object.subAccount)
            : account_1.AccountSubAccount.fromPartial({});
        return message;
    },
};
class InstallmentLoanServiceClient {
    rpc;
    name = 'com.step.account.proto.InstallmentLoanService';
    type = rpc_1.ServiceType.PUBLIC;
    path = '/account';
    methods = [{
            name: 'SetInstallmentLoanAutoPay',
            requestType: exports.SetInstallmentLoanAutoPayRequest,
            responseType: exports.SetInstallmentLoanAutoPayResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'LookupInstallmentLoan',
            requestType: exports.LookupInstallmentLoanRequest,
            responseType: exports.LookupInstallmentLoanResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    /**
     * Set the autoPay flag for an installment loan.
     */
    setInstallmentLoanAutoPay(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Returns the sub-account installment loan for the specified payment id.
     * This would typically be used to retrieve a specific installment loan
     * sub-account which may be closed, and thus not in the listed active
     * sub-accounts for the account.
     */
    lookupInstallmentLoan(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[1],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.InstallmentLoanServiceClient = InstallmentLoanServiceClient;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=installment-loan-service.js.map